var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6878 7.3125V11.8125M7.31277 7.3125V11.8125M15.1875 3.9375L2.8125 3.93751M14.0628 3.9375V14.625C14.0628 14.7742 14.0035 14.9173 13.898 15.0227C13.7925 15.1282 13.6495 15.1875 13.5003 15.1875H4.50027C4.35109 15.1875 4.20802 15.1282 4.10253 15.0227C3.99704 14.9173 3.93777 14.7742 3.93777 14.625V3.9375M11.8128 3.9375V2.8125C11.8128 2.51413 11.6942 2.22798 11.4833 2.017C11.2723 1.80603 10.9861 1.6875 10.6878 1.6875H7.31277C7.01441 1.6875 6.72826 1.80603 6.51728 2.017C6.3063 2.22798 6.18777 2.51413 6.18777 2.8125V3.9375",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/TrashAlt.eee55d649c88555986b8dafb2a896ff5.svg";
export { ForwardRef as ReactComponent };